<template>
  <v-container v-if="$can('sensitive-data')" fluid>
    <alert-error :error="error" />

    <v-toolbar>
      <v-toolbar-title>{{
        $t('SUBSCRIPTIONS.SUBSCRIPTION_MANAGEMENT')
      }}</v-toolbar-title>

      <v-spacer />

      <v-btn dark color="indigo" @click="$router.go(-1)">
        {{ $t('BUTTON.BACK') }}
      </v-btn>
    </v-toolbar>

    <v-sheet class="mt-5 pa-5" tile>
      <subscriptions-filter @setFilters="setFilters" />

      <subscriptions-list
        :items="items"
        :meta="meta"
        :options.sync="options"
        @show="show"
      />

      <v-row>
        <v-btn @click="exportFile">{{ $t('BUTTON.EXPORT') }}</v-btn>
      </v-row>

      <v-dialog v-if="dialog" v-model="dialog" max-width="600" persistent>
        <edit-subscription
          :id="subscription.id"
          @cancel="cancelDialog"
          @updated="cancelDialogAndRefresh"
        />
      </v-dialog>
    </v-sheet>
  </v-container>
</template>

<script>
import DataOptions from '@/modules/_global/classes/DataOptions';
import { dateFormatUnderscore } from '@/modules/_global/filters';
import { cloneDeep, debounce, isEmpty } from 'lodash';
import downloadFile from '@/modules/_global/mixins/download-file';
import { mapActions, mapState } from 'vuex';
import listOptions from '@/modules/_global/mixins/list-options';

export default {
  name: 'SubscriptionsPage',

  components: {
    SubscriptionsList: () => import('../components/SubscriptionsList'),
    SubscriptionsFilter: () =>
      import('../components/forms/SubscriptionsFilterForm'),
    EditSubscription: () => import('../components/EditSubscription'),
    AlertError: () => import('@/modules/_global/_components/AlertError')
  },

  mixins: [downloadFile, listOptions],

  data() {
    return {
      error: null,
      subscriptions: [],
      meta: {
        total: 0
      },
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['id'],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        mustSort: false,
        multiSort: false
      },
      filters: {},
      dialog: false,
      subscription: null
    };
  },

  computed: {
    ...mapState('subscription', ['paginationOptions'])
  },

  methods: {
    ...mapActions('subscription', ['getItemsList', 'getSubscriptionsExport']),

    show(item) {
      this.dialog = true;
      this.subscription = item;
    },

    cancelDialog() {
      this.dialog = false;
      this.subscription = null;
    },

    cancelDialogAndRefresh() {
      this.cancelDialog();
      this.refreshData();
    },

    exportFile() {
      this.getSubscriptionsExport(this.filters)
        .then(response => {
          const filename = this.$t('SUBSCRIPTIONS.ITEMS');
          const date = dateFormatUnderscore(new Date());

          this.downloadFile(response, `${filename} ${date}.xlsx`);
        })
        .catch(error => {
          this.$emit('error', error);
        });
    }
  }
};
</script>
